import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import NewLayout from './views/NewLayout.vue'
import UserGuide from './views/UserGuide.vue'
import Transactions from './views/Transactions.vue'
import BranchLocator from './views/BranchLocator.vue'
import Scheduler from './views/Scheduler.vue'
import Profile from './views/Profile.vue'
import Motorcycle from './views/Motorcycle.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
    {
            path: '/',
            name: 'newlayout',
            component: NewLayout,
            redirect: '/branch-locator',
            meta : {
                public: true,
            },
            children: [
                {
                    path: '/branch-locator',
                    name: 'branch-locator',
                    component: BranchLocator,
                    meta : {
                        public: true,
                    }
                },
                {
                    path: '/transactions',
                    name: 'transactions',
                    component: Transactions,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/userguide',
                    name: 'userguide',
                    component: UserGuide,
                    meta : {
                        public: true,
                    }
                },
                {
                    path: '/branch-locator',
                    name: 'branch-locator',
                    component: BranchLocator,
                    meta : {
                        public: true,
                    }
                },
                {
                    path: '/service-scheduler/:branch/:branchCode/:id/:step',
                    name: 'service-scheduler',
                    component: Scheduler,
                    meta : {
                        public: true,
                    }
                },
            ]

        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta : {
                public: true,
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout,
            meta : {
                public: true,
            }
        },
        {
            path: '/motorcycle',
            name: 'motorcycle',
            component: Motorcycle,
            meta : {
                public: true,
            }
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta : {
                public: true,
            }
        },
    ]
})
